import React from 'react';
import ClickAwayListener from 'react-click-away-listener';
import { Button } from '@ui';
import { Popup } from '@progress/kendo-react-popup';
import { translate } from '@utils/i18n';
import { namespace } from '../constants';
function CollectOptionsButton({ proposal }) {
    var _a, _b, _c;
    const collectAnchor = React.useRef(null);
    const [collectOpen, setCollectOpen] = React.useState(false);
    const handleCloseCollect = () => {
        setCollectOpen(false);
    };
    const handleCollect = () => {
        setCollectOpen(true);
    };
    const hasPayrixMerchant = (_a = proposal.tenantCapabilities) === null || _a === void 0 ? void 0 : _a.hasPayrixMerchant;
    const isCollectDisabled = !hasPayrixMerchant || proposal.totalAmount === 0 || !proposal.showChargeButton;
    const canManagePayments = ((_b = proposal.userPermissions) === null || _b === void 0 ? void 0 : _b.managePaymentMethods) && ((_c = proposal.tenantCapabilities) === null || _c === void 0 ? void 0 : _c.enableBackendPayments);
    const getCollectButtonTitle = () => {
        if (!hasPayrixMerchant) {
            return translate('disabled_create_payment_button_no_merchant', { namespace });
        }
        if (proposal.totalAmount === 0) {
            return translate('disabled_create_payments', { namespace });
        }
        if (!proposal.showChargeButton) {
            return translate('disabled_create_payment_button_title', { namespace });
        }
        return '';
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(Button, { variant: "secondary", ref: collectAnchor, onClick: handleCollect, disabled: isCollectDisabled, title: getCollectButtonTitle() },
            React.createElement("i", { className: "fa-light fa-money-bills" }),
            " ",
            translate('collect', { namespace })),
        !isCollectDisabled && (React.createElement(Popup, { anchor: collectAnchor.current, show: collectOpen, onClose: handleCloseCollect },
            React.createElement(ClickAwayListener, { onClickAway: handleCloseCollect },
                React.createElement("div", { id: "popup_convert", className: "qmb-popup--action-list" },
                    React.createElement("ul", { role: "presentation" }, hasPayrixMerchant && (React.createElement("li", { role: "presentation" }, canManagePayments ? (React.createElement("button", { onClick: () => {
                            var _a;
                            (_a = window.showChargeModalV2) === null || _a === void 0 ? void 0 : _a.call(window, 'Proposal', proposal.id);
                        }, type: "button" },
                        React.createElement("i", { className: "fa-light fa-credit-card" }),
                        translate('payment', { namespace }))) : (React.createElement("button", { type: "button", disabled: true, title: translate('disabled_unpermitted_button_title', { namespace }) },
                        React.createElement("i", { className: "fa-light fa-credit-card" }),
                        translate('payment', { namespace }))))))))))));
}
export default CollectOptionsButton;
